import React, { useState } from "react";
import Form from "../../../Components/Form";
import UsersMultiSelectDropdown from "../../../Components/Dropdown/Users/UsersMultiSelectDropdown";
import DynamicMultiSelectDropdown from "../../../Components/Dropdown/DynamicMultiSelectDropdown";
import { getGroups } from "../../../Requests/optionDomain";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";
import {
  addDeltaHedgeExeManagementTask,
  editDeltaHedgeExeManagementTask,
  getDeltaHedgeExeStrategies,
} from "../../../Requests/deltaHedgeExe";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import { getDeltaHedgeAccountsDropdown } from "../../../Requests/deltaHedgeAccounts";
// Common components
import { DynamicDropdown, StaticDropdown } from "src/Components";
// Types
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import {
  IDeltaHedgeExeManagementAddEditTaskDTO,
  IAdjustmentType,
} from "../../../Interfaces/deltaHedgeExe";

interface IProps {
  editValues: IDeltaHedgeExeManagementAddEditTaskDTO | null;
  onSuccess: () => void;
  onClose: () => void;
}
const adjustmentTypeOptions: DropdownItem[] = [
  { id: IAdjustmentType.OffsetPlusAll, name: "آفستی + ورودی همه" },
  { id: IAdjustmentType.OffsetPlusProperty, name: "آفستی + ورودی دارایی" },
  { id: IAdjustmentType.Offset, name: "آفستی" },
];

const AddEditTask = ({ editValues, onSuccess, onClose }: IProps) => {
  const [formValues, setFormValues] = useState(
    editValues || ({} as IDeltaHedgeExeManagementAddEditTaskDTO)
  );
  const [loading, setLoading] = useState(false);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const checkDisabled = () => {
    if (
      !formValues.accountIds ||
      !formValues.accountIds.length ||
      !formValues.deltaTolerancePercent?.toString() ||
      !formValues.gammaTolerancePercent?.toString() ||
      !formValues.groupIds ||
      !formValues.groupIds.length ||
      !formValues.accountIds.length ||
      !formValues.targetDeltaPercent?.toString() ||
      !formValues.targetGammaPercent?.toString()
    )
      return true;
    return false;
  };

  const getProperFunction = () => {
    if (editValues) return editDeltaHedgeExeManagementTask(formValues);
    return addDeltaHedgeExeManagementTask(formValues);
  };

  const clickHandler = () => {
    setLoading(true);
    getProperFunction()
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onSuccess();
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      {loading ? <FullScreenLoading /> : <></>}
      {editValues ? (
        <></>
      ) : (
        <>
          <DynamicMultiSelectDropdown
            dropdown={{
              placeholder: "اکانت",
              name: "accountIds",
              extraLabel: true,
            }}
            onChange={changeHandler}
            value={formValues.accountIds}
            getData={getDeltaHedgeAccountsDropdown}
          />
          <DynamicMultiSelectDropdown
            dropdown={{
              placeholder: "گروه ها",
              name: "groupIds",
              extraLabel: true,
            }}
            getData={getGroups}
            value={formValues.groupIds}
            onChange={changeHandler}
          />
        </>
      )}

      <TextInput
        label="% دلتای هدف"
        name="targetDeltaPercent"
        value={formValues.targetDeltaPercent?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="% گاما هدف"
        name="targetGammaPercent"
        value={formValues.targetGammaPercent?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="واحد % تلورانس دلتا"
        name="deltaTolerancePercent"
        value={formValues.deltaTolerancePercent?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="واحد % تلورانس گاما"
        name="gammaTolerancePercent"
        value={formValues.gammaTolerancePercent?.toString()}
        onChange={changeHandler}
        extraLabel
      />

      <DynamicDropdown
        dropdown={{
          name: "strategyId",
          placeholder: "استراتژی",
          extraLabel: true,
        }}
        getData={getDeltaHedgeExeStrategies}
        onChange={changeHandler}
        value={formValues.strategyId}
      />

      <StaticDropdown
        dropdown={{
          name: "adjustmentType",
          placeholder: "روش تعدیل",
          extraLabel: true,
        }}
        options={adjustmentTypeOptions}
        onChange={changeHandler}
        value={formValues.adjustmentType}
      />

      <Button
        text={editValues ? "ویرایش" : "اضافه کردن"}
        onClick={clickHandler}
        variant="contained"
        disabled={checkDisabled()}
      />
    </Form>
  );
};

export default AddEditTask;
